<template>
  <el-container v-title data-title="退款记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>退款记录</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="退款者用户名">
                  <el-input v-model="searchForm.receiverUserName" placeholder="退款者用户名"></el-input>
                </el-form-item>
                <el-form-item label="学生姓名">
                  <el-input v-model="searchForm.studentRealName" placeholder="学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getRefundList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="id" label="退款单编号" width="310"></el-table-column>
          <el-table-column prop="orderNo" label="订单编号" width="310"></el-table-column>
          <el-table-column prop="receiverUserName" label="退款者用户名" width="140"></el-table-column>
          <el-table-column prop="studentRealName" label="学生姓名" width="100"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="110"></el-table-column>
          <el-table-column prop="className" label="班级" width="80"></el-table-column>
          <el-table-column prop="amount" label="退款金额" :formatter="formatYuan" width="80"></el-table-column>
          <el-table-column prop="wechatRefundNo" label="微信退款单号" width="280"></el-table-column>
          <el-table-column prop="insertTime" label="生成时间" width="170"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="80"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getRefundList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {},
      schoolList: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
      this.getRefundList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getRefundList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getRefundList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/refund/list',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          receiverUserName: _this.searchForm.receiverUserName,
          studentRealName: _this.searchForm.studentRealName,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    formatYuan: function (row, column) {
      return row.amount / 100
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Refund.vue